export default __webpack_public_path__ + "static/media/16.ebf802d0.png";